const containerStack = {
  gap: '3rem',
  padding: {
    xs: '4rem 2rem 4rem 2rem',
    desktop: '7.5rem 14rem 5.625rem 14rem',
  },
  alignSelf: 'stretch',
  backgroundColor: 'white',
};

const titleTypography = (theme) => ({
  fontSize: { xs: '2.5rem', ipad: '3rem', md: '3.375rem' },
  textAlign: 'center',
  color: theme.palette.neutral.A700,
});

const faqsStack = {
  gap: '1.25rem',
  maxWidth: '80rem',
  width: '100%',
};

const accordionStyles = {
  width: '100%',
  '&:before': {
    display: 'none',
  },
  border: 'none',
  padding: 0,
  borderRadius: '0.75rem',
  margin: 0,
  '& .MuiCollapse-root': {
    transition: 'none',
  },
  '& .MuiCollapse-hidden': {
    maxHeight: 0,
    opacity: 0,
  },
};

const accordionSummary = (theme, isExpanded) => ({
  display: 'flex',
  padding: '1rem',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignSelf: 'stretch',
  borderRadius: '0.75rem 0.75rem 0 0',
  backgroundColor: isExpanded ? theme.palette.contrast.A700 : 'white',
  transition: 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.1s ease-in-out',
});

const questionTypography = (theme, isExpanded) => ({
  color: isExpanded ? theme.palette.primary.A700 : theme.palette.neutral.A700,
  padding: { xs: '0 1rem', ipad: '0 1.5rem' },
});

const accordionDetails = (theme) => ({
  display: 'flex',
  padding: '1.5rem',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'stretch',
  backgroundColor: theme.palette.contrast.A700,
  borderRadius: '0 0 0.75rem 0.75rem',
});

const answerTypography = {
  padding: '0 1rem',
  whiteSpace: 'pre-wrap',
  marginBottom: '1.5rem',
  color: 'white',
};

const buttonTypography = {
  color: 'white',
  fontWeight: 600,
};

export {
  containerStack,
  titleTypography,
  faqsStack,
  accordionStyles,
  accordionSummary,
  questionTypography,
  accordionDetails,
  answerTypography,
  buttonTypography,
};
